import React, { useEffect, useState } from 'react';
import { listTrades, enableAlertTrade, updateAlertTrade, deleteAlertTrade } from './../../actions/zerodhaActions';
import { useDispatch, useSelector } from 'react-redux';
import { getForms } from '../../actions/formActions';
import ReactModal from 'react-modal';
import SearchBoxWithListing from '../../components/Common/SearchBoxWithListing';
import SearchBox from '../Common/SearchBox/SearchBox';
import { FaTimes } from 'react-icons/fa'; // Importing the plus icon
import _ from "lodash"

const ZerodhaTrades = (props) => {
    const searchBoxKey = "ZERODHA_trades_search_form";
    const listFormKey = "ZERODHA_trades_list_form";
    const editFormKey = "ZERODHA_trades_edit_form";
    const dispatch = useDispatch();
    const zerodhaState = useSelector((state) => state.zerodha);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const editFormJson = formJson[editFormKey] || {};
    const { trades = {}, updateTrade = {} } = zerodhaState;
    const [fetchingList, setFetchingList] = useState(_.isEmpty(trades));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updatePayload, setUpdatePayload] = useState({});

    useEffect(() => {
        if (!_.isEmpty(trades) && fetchingList) {
            setFetchingList(false);
        }
    }, [trades])

    const actionsHandling = (action, rowData) => {
        const { enabled = false, alertTradeId = '', profitTargetPercentage, stopLossPercentage, sellConditions = [], buyAtEveryDip = [], buyOrderExecuted = false, buyOrders = [] } = rowData;
        const _buyAtEveryDip = buyAtEveryDip.map(dip => {
            return { dipPercent: dip[0], buyPercent: dip[1] }
        });
        switch (action.id) {
            case "enabled": {
                dispatch(enableAlertTrade({ enabled, alertTradeId }));
                break;
            }
            case "edit": {
                setUpdatePayload({
                    genericFields: { alertTradeId, profitTargetPercentage, stopLossPercentage, sellConditions, buyOrderExecuted },
                    buyAtEveryDip: _buyAtEveryDip,
                    buyOrders
                });
                break;
            }
            case "delete": {
                dispatch(deleteAlertTrade(alertTradeId));
                break;
            }
        }
    }

    useEffect(() => {
        if (!_.isEmpty(updatePayload)) {
            setIsModalOpen(true);
        }
    }, [updatePayload]);

    useEffect(() => {
        if (!_.isEmpty(updateTrade)) {
            const { status = {} } = updateTrade;
            const { success = false } = status;
            if (success) {
                window.location.reload();
            }
        }
    }, [updateTrade]);

    useEffect(() => {
        dispatch(getForms(listFormKey, searchBoxKey));
        dispatch(getForms(editFormKey));
    }, []);

    const listApi = (payload) => {
        setFetchingList(true);
        return dispatch(listTrades(payload, listFormKey));
    }

    const updateApi = (payload) => {
        // Call the API to update the trade alert with the new payload
        // You can dispatch an action here to update the trade alert in the backend
        const { genericFields = {}, buyAtEveryDip = [], buyOrders = [] } = payload;
        const { alertTradeId = '', ...restData } = genericFields;
        const _buyAtEveryDip = buyAtEveryDip.map(dip => {
            const { dipPercent = 0, buyPercent = 0 } = dip;
            return [dipPercent, buyPercent]
        });

        const buyPrices = buyOrders.map(data => data.price);
        const buyQties = buyOrders.map(data => data.qty);
        const buyDates = buyOrders.map(data => data.date);
        const quantity = buyQties.reduce((accum, data) => accum + data, 0)

        dispatch(updateAlertTrade({
            ...payload, buyAtEveryDip: _buyAtEveryDip, genericFields: { ...restData },
            tradeInfo: {
                buyPrices, buyQties, buyDates, quantity
            }
        }, alertTradeId));
        // setIsModalOpen(false);
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={trades}
                actionsHandling={actionsHandling}
            />
            <ReactModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                style={{
                    content: {
                        position: 'relative',
                        inset: 'auto',
                        margin: '0',
                        transform: 'none',
                        width: 'min(900px, 92vw)',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        padding: '20px',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2000,
                    },
                }}
            >
                <button
                    onClick={() => setIsModalOpen(false)}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                    }}
                    aria-label="Close"
                >
                    <FaTimes />
                </button>
                <div>
                    <SearchBox
                        searchBoxJson={editFormJson}
                        placeholder="Search and select"
                        updatedValues={updatePayload}
                        onSearch={updateApi}
                    />
                </div>
            </ReactModal>
        </div>

    )
}

export default ZerodhaTrades;
